import React, { useEffect, useState } from "react";
import { Card, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow, Chip } from "@material-ui/core";
import { Button, IconButton, InputBase, Paper, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, Divider } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useQuery } from 'react-query';
import { ORDERS, PAYOUT } from "src/api/axios";
import UserListHead from "src/components/user/UserListHead";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import Stack from '@mui/material/Stack';
import { useSnackbar } from "notistack";
import { useTheme } from '@mui/material/styles';
import SearchIcon from "src/svgComponents/SearchIcon";
import LoadingScreen from "src/components/LoadingScreen";
import moment from "moment";
const _ = require('lodash');

const TransactionList = () => {
	const [tableData, setTableData] = useState([]);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [order, setOrder] = useState('asc');
	const [orderBy, setOrderBy] = useState('name');
	const axiosPrivate = useAxiosPrivate();
	const [showImage, setShowImage] = useState();
	const [filterName, setFilterName] = useState('');
	const { enqueueSnackbar } = useSnackbar();
	const [deleteId, setdeleteId] = useState("");
	const [open, setOpen] = useState(false);
	const theme = useTheme();
	const [loding, setLoding] = useState(true);
	const [totalEarning, setTotalEarning] = useState();
	const [totalPayout, setTotalPayout] = useState();
	const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

	const StyledTableRow = styled(TableRow)(({ theme }) => ({
		'&:nth-of-type(odd)': {
			backgroundColor: '#ffffff',
		},
		'&:nth-of-type(even)': {
			background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
		},
		// hide last border
		'& td, & th': {
			border: 0,
		},
	}));

	const TABLE_HEAD = [
		{ id: 'name', label: 'Approve By', alignRight: false },
		{ id: 'email', label: 'Email', alignRight: false },
		{ id: 'transaction_id', label: 'Transaction Id', alignRight: false },
		{ id: 'transaction_msg', label: 'Transaction Note', alignRight: false },
		{ id: 'createdAt', label: 'Transaction Date', alignRight: false },
		{ id: 'deduction', label: 'Fees Charge', alignRight: false },
		{ id: 'payout_amount', label: 'Payout Amount', alignRight: false },
		{ id: 'amount', label: 'Total Charge', alignRight: false },
	];

	async function getTransactionList(page, filterName) {
		const response = await axiosPrivate.get(PAYOUT.getTransactionList, { params: { page: page + 1, search: filterName, limit: rowsPerPage } })
		setTotalEarning(response.data.total_earning)
		setTotalPayout(response.data.total_payout)
		return response.data.transactionList;
	}

	const { data: pendingPayoutList, refetch } = useQuery(['pendingPayoutList', page, filterName], () => getTransactionList(page, filterName), { keepPreviousData: true, })

	useEffect(() => {
		if (pendingPayoutList) {
			setTableData(pendingPayoutList.data);
			setRowsPerPage(pendingPayoutList?.metadata.length != 0 ? pendingPayoutList?.metadata[0].limit : 10);
		}
		if (pendingPayoutList?.metadata.length != 0 && pendingPayoutList?.metadata[0].hasMoreData == true) {
			getTransactionList(page + 1);
		}
		setLoding(false);
	}, [pendingPayoutList])

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
		setTimeout(() => {
			refetch();
		}, 500);
	};
	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};
	const handleFilterByName = (event) => {
		setFilterName(event.target.value.trim());
		setPage(0);
		getTransactionList(page, filterName)
		refetch();
	};

	function descendingComparator(a, b, orderBy) {
		if (b[orderBy] < a[orderBy]) {
			return -1;
		}
		if (b[orderBy] > a[orderBy]) {
			return 1;
		}
		return 0;
	}

	function getComparator(order, orderBy) {
		return order === 'desc'
			? (a, b) => descendingComparator(a, b, orderBy)
			: (a, b) => -descendingComparator(a, b, orderBy);
	}
	function applySortFilter(array, comparator) {
		const stabilizedThis = array.map((el, index) => [el, index]);
		stabilizedThis.sort((a, b) => {
			const order = comparator(a[0], b[0]);
			if (order !== 0) return order;
			return a[1] - b[1];
		});

		return stabilizedThis.map((el) => el[0]);
	}

	const handleRequestSort = (event, property) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};

	const filteredUsers = applySortFilter(tableData, getComparator(order, orderBy));

	const handleClose = () => {
		setOpen(false);
		setShowImage('');
	};

	const deleteOrder = async () => {
		const response = await axiosPrivate.delete(ORDERS.deleteOrder + deleteId)
		if (response.status == 200) {
			enqueueSnackbar("Order delete successfully", {
				variant: "success",
				anchorOrigin: { vertical: "top", horizontal: "right" },
				autoHideDuration: 2000,
			});
		} else {
			enqueueSnackbar("something went wrong", {
				variant: "error",
				anchorOrigin: { vertical: "top", horizontal: "right" },
				autoHideDuration: 2000,
			});
		}
		refetch();
		handleClose();
	};

	return (
		<>
			{loding ? <LoadingScreen /> : <>
				<div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 row-cols-xxl-4 g-4">
					<div className="col">
						<div className="card text-center  dashboard_card">
							<div className="justify-content-evenly card-header app_text_14_bold app_text_black">
								Total Earning
							</div>
							<div className="card_content">
								<Stack spacing={2}>
									<span className="app_text_30_500 app_text_black_3">{totalEarning}</span>
								</Stack>
							</div>
						</div>
					</div>
					<div className="col">
						<div className="card text-center  dashboard_card">
							<div className="justify-content-evenly card-header app_text_14_bold app_text_black">
								Total Payout
							</div>
							<div className="card_content">
								<Stack spacing={2}>
									<span className="app_text_30_500 app_text_black_3">{totalPayout}</span>
								</Stack>
							</div>
						</div>
					</div>
					{/* <div className="col">
						<div className="card text-center  dashboard_card">
							<div className="justify-content-evenly card-header app_text_14_bold app_text_black">
								Total Transaction
							</div>
							<div className="card_content">
								<Stack spacing={2}>
									<span className="app_text_30_500 app_text_black_3">{totalCompletedPayout}</span>
								</Stack>
							</div>
						</div>
					</div> */}
				</div>
				<Divider sx={{ my: 5, borderBottom: '1.5px solid' }} />
				<div className="dashboard_header mb-4">
					<h4 className="app_text_20_semibold mb-0 d-flex align-items-center">Transaction List</h4>
					<Paper component="form" className='dashboard_searchbox col-lg-4'>
						<IconButton>
							<SearchIcon />
						</IconButton>
						<InputBase
							fullWidth
							sx={{ flex: 1 }}
							placeholder="search ..."
							onChange={(e) => handleFilterByName(e)}
							onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
						/>
					</Paper>
				</div>
				<Card>
					<TableContainer>
						<Table>
							<UserListHead
								headLabel={TABLE_HEAD}
								rowCount={pendingPayoutList?.data?.length}
								onRequestSort={handleRequestSort}
							/>
							{filteredUsers?.length > 0 ?
								<TableBody>
									{filteredUsers.map((row) => {
										return (
											<StyledTableRow key={row._id}>
												<TableCell component="th" scope="row"> {row?.admin_data?.name} </TableCell>
												<TableCell component="th" scope="row"> {row?.admin_data?.email} </TableCell>
												<TableCell component="th" scope="row"> {row?.transaction_id} </TableCell>
												<TableCell component="th" scope="row"> {row?.transaction_msg} </TableCell>
												<TableCell align="left"> {moment(row.createdAt).format("DD MMM YYYY h:mm A")}</TableCell>
												<TableCell align="left"> {row?.deduction} </TableCell>
												<TableCell align="left"> {row?.payout_amount} </TableCell>
												<TableCell component="th" scope="row"> {row?.amount} </TableCell>
											</StyledTableRow>
										)
									})}
								</TableBody>
								:
								<TableBody>
									<TableRow>
										<TableCell align="center" colSpan={9} sx={{ py: 5 }}>
											<span className="app_text_16_semibold">No Data Found</span>
										</TableCell>
									</TableRow>
								</TableBody>}
						</Table>
					</TableContainer>
					<TablePagination
						component="div"
						rowsPerPageOptions={[10, 20, 50, 100]}
						count={pendingPayoutList?.metadata.length != 0 ? pendingPayoutList?.metadata[0].total : 0}
						rowsPerPage={rowsPerPage}
						page={page}
						onPageChange={handleChangePage}
						onRowsPerPageChange={handleChangeRowsPerPage}
					/>
				</Card>
			</>
			}
			<Dialog
				fullScreen={fullScreen}
				open={open}
				onClose={handleClose}
				aria-labelledby="responsive-dialog-title"
			>
				<DialogTitle id="responsive-dialog-title" className='m-auto'>
					{"are you sure you want to delete?"}
				</DialogTitle>
				<DialogContent>
				</DialogContent>
				<DialogActions className='m-auto'>
					<Button className="theme_button_view" variant="contained" autoFocus onClick={handleClose}>
						cancel
					</Button>
					<Button className="theme_button" variant="contained" onClick={() => deleteOrder()} autoFocus>
						delete
					</Button>
				</DialogActions>
			</Dialog>
		</>
	)
}

export default TransactionList